<template>
  <div>
    <log-list class="p-5"></log-list>
  </div>
</template>

<script>
  import LogList from '@/components/administration/log/common/LogList'

  export default {
    components: {
      'log-list': LogList
    }
  }
</script>
